import * as React from 'react';
import { render } from 'react-dom';
import { Provider } from 'react-redux';
import FestivalOverviewContainer from '../festival-overview-page/components/festival-overview-container';
import { festivalOverviewStore } from './redux/index';
import { BrowserRouter } from 'react-router-dom';
import { RouterToUrlQuery, addUrlProps, UrlQueryParamTypes, subquery, configureUrlQuery, urlQueryMiddleware } from 'react-url-query';

configureUrlQuery({ history, addChangeHandlers: false });

render(
    <Provider store={festivalOverviewStore}>
        <BrowserRouter>
            <RouterToUrlQuery>
                <FestivalOverviewContainer />
            </RouterToUrlQuery>
        </BrowserRouter>
    </Provider>
    , document.querySelector("[data-festival-overview-page]"));